import React from 'react'
import './App.css';
import './styles/general.scss'
import './styles/font_iconset/iconfont.css'
import Router from "./router/"
import {SessionProvider} from './store/sessionContext'
// import {IdleTimerProvider} from './store/idleTimerContext'
import { LanguageProvider } from './store/languageContext'
import {PropertyParamsProvider} from './store/propertyParamsContext'


function App() {
  return (
    <SessionProvider>
      {/* <IdleTimerProvider timeout={600}> {/*seconds*/}
        <LanguageProvider>
          <PropertyParamsProvider> 
              <div className="App">
                <Router />
              </div>
        </PropertyParamsProvider>    
        </LanguageProvider>
      {/* </IdleTimerProvider> */}
    </SessionProvider>
  );
}

export default App;
